import { httpClient } from "./http-client";
import { NEW_API_ENDPOINTS } from "../../shared/constants/api";
import type { ApiResponse, CreateMachineProductCommand } from "../../shared/types/api";
import type { MachineProductEntity } from "../../domain/types/machine-product";

export class MachineProductApiService {
  async createMachineProduct(
    request: CreateMachineProductCommand,
  ): Promise<ApiResponse<MachineProductEntity>> {
    const response = await httpClient.post<ApiResponse<MachineProductEntity>>(
      NEW_API_ENDPOINTS.machineProductController.POST,
      request,
    );

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "machine product 생성 실패.");
    }

    return response.data;
  }

  async searchMachineProduct(machineId: number): Promise<ApiResponse<MachineProductEntity[]>> {
    const response = await httpClient.get<ApiResponse<MachineProductEntity[]>>(
      NEW_API_ENDPOINTS.machineProductController.GET,
      {
        params: { machineId },
      },
    );

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "machine product 검색 실패.");
    }

    return response.data;
  }
}

export const machineProductApiService = new MachineProductApiService();